import {
  BankReferenceType,
  ContactDuplicateType,
  DepartmentType,
  MerchantType,
  PeakExceptionResponseCode,
  PrefixNameType,
  TypeOfPerson,
  FinanceType,
  TransactionType,
} from "@/enums/enums";
import router from "@/router";
import { GetTypeOfPersonBySearchedAddress } from "./shareHelper";

export function SetContactCreateTemplate(isChangeContactTemplate = true, contactCreateTemplate?: any) {
  return {
    id: 0,
    contactBranchId: 0,
    modalCreateType: 1,
    logoUrl: "",
    taxId: {
      value: isChangeContactTemplate ? "" : contactCreateTemplate.taxId.value,
      validateError: false,
    },
    branchTypeId: isChangeContactTemplate ? 1 : contactCreateTemplate.branchTypeId,
    branchCode: {
      value: isChangeContactTemplate ? "" : contactCreateTemplate.branchCode.value,
      validateError: false,
    },
    contactContryId: 1,
    contactCode: {
      value: isChangeContactTemplate ? "" : contactCreateTemplate.contactCode.value,
      validateError: false,
    },
    typeOfPerson: { value: 2 },
    contactName: "",
    typeCompany: "",
    otherTypeCompany: "",
    companyName: {
      value: "",
      validateError: false,
    },
    prefixName: { value: PrefixNameType.Mr },
    prefixOtherName: {
      value: "",
      validateError: false,
    },
    firstname: {
      value: "",
      validateError: false,
    },
    lastname: {
      value: "",
      validateError: false,
    },
    registeredAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    shippingAddress: {
      contactName: {
        value: "",
        validateError: false,
      },
      address: {
        value: "",
        validateError: false,
      },
      road: {
        value: "",
        validateError: false,
      },
      building: {
        value: "",
        validateError: false,
      },
      city: {
        value: "",
        validateError: false,
      },
      state: {
        value: "",
        validateError: false,
      },
      district: {
        value: "",
        validateError: false,
      },
      amphoe: {
        value: "",
        validateError: false,
      },
      province: {
        value: "",
        validateError: false,
      },
      zipcode: {
        value: "",
        validateError: false,
      },
      country: { name: "Thailand", code: "TH" },
    },
    email: {
      value: "",
      validateError: false,
    },
    phoneNumber: {
      value: "",
      validateError: false,
    },
    faxNumber: {
      value: "",
      validateError: false,
    },
    website: {
      value: "",
      validateError: false,
    },
    personToContact: [
      {
        id: 0,
        prefixName: { value: PrefixNameType.None },
        prefixOtherName: {
          value: "",
          validateError: false,
        },
        firstName: {
          value: "",
          validateError: false,
        },
        lastName: {
          value: "",
          validateError: false,
        },
        nickName: {
          value: "",
          validateError: false,
        },
        department: { value: DepartmentType.None },
        departmentOther: {
          value: "",
          validateError: false,
        },
        position: {
          value: "",
          validateError: false,
        },
        email: {
          value: "",
          validateError: false,
        },
        phoneNumber: {
          value: "",
          validateError: false,
        },
      },
    ],
    bankInformation: [
      {
        id: 0,
        bank: {
          name: "",
          bankReferenceBankId: BankReferenceType.NONE,
        },
        accountName: {
          value: "",
          validateError: false,
        },
        accountNumber: {
          value: "",
          validateError: false,
        },
        bankBranch: {
          value: "",
          validateError: false,
        },
      },
    ],
    setDueDate: {
      dayForExpenses: {
        value: "7",
        validateError: false,
      },
      dayForInvoicePayment: {
        value: "7",
        validateError: false,
      },
      dueToExpenses: { name: "", value: 0 },
      dueToInvoicePayment: { name: "", value: 0 },
    },
    accountRecordSetting: {
      selectReceivableRecorded: { id: 7 },
      selectPayableRecorded: { id: 58 },
    },
    contactGroup: [
      {
        name: "",
      },
    ],
    contactCreditLimit: {
      value: "0.00",
      validateError: false,
    },
  };
}

export function SetContactCreateTemplateBySearchedContactAddress(contactCreateTemplate: any, searchedAddress: any) {
  contactCreateTemplate.taxId.value = searchedAddress.taxId;
  contactCreateTemplate.branchCode.value = searchedAddress.branchCode;
  contactCreateTemplate.logoUrl = searchedAddress.logoUrl;
  contactCreateTemplate.typeOfPerson = GetTypeOfPersonBySearchedAddress(searchedAddress.merchantType);
  contactCreateTemplate.typeCompany = { value: searchedAddress.merchantType };
  if (
    contactCreateTemplate.typeOfPerson.value === TypeOfPerson.OrdinaryPerson &&
    searchedAddress.merchantType === MerchantType.OrdinaryPerson
  ) {
    const fullName = searchedAddress.name.split(" ");
    contactCreateTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
    contactCreateTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
    contactCreateTemplate.prefixName = { value: searchedAddress.personalNamePrefixTypeId };
  } else {
    contactCreateTemplate.companyName.value = searchedAddress.name;
  }
  contactCreateTemplate.registeredAddress.address.value = `${
    searchedAddress.no ? "เลขที่ " + searchedAddress.no : ""
  } ${searchedAddress.homeNo ? "หมู่ " + searchedAddress.homeNo : ""} ${
    searchedAddress.roomNo ? "ห้อง " + searchedAddress.roomNo : ""
  } ${searchedAddress.floorNo ? "ชั้น " + searchedAddress.floorNo : ""} ${
    searchedAddress.building ? "อาคาร " + searchedAddress.building : ""
  } ${searchedAddress.soi ? "ซอย " + searchedAddress.soi : ""} ${
    searchedAddress.road ? "ถนน " + searchedAddress.road : ""
  }`;
  contactCreateTemplate.registeredAddress.district.value = searchedAddress.subDistrict;
  contactCreateTemplate.registeredAddress.amphoe.value = searchedAddress.district;
  contactCreateTemplate.registeredAddress.province.value = searchedAddress.province;
  contactCreateTemplate.registeredAddress.zipcode.value = searchedAddress.postCode;
  contactCreateTemplate.email.value = searchedAddress.email ? searchedAddress.email : "";
  contactCreateTemplate.phoneNumber.value = searchedAddress.phone ? searchedAddress.phone : "";
  contactCreateTemplate.website.value = searchedAddress.website ? searchedAddress.website : "";
  contactCreateTemplate.faxNumber.value = searchedAddress.fax ? searchedAddress.fax : "";
}

export function RedirectContactCreateSuccess(contactId: number, transactionTypeModel: any) {
  switch (transactionTypeModel.transactionType) {
    case TransactionType.Quotation:
      if (transactionTypeModel.financeType == FinanceType.InFlow) {
        router.push({ name: "quotationCreate", query: { eci: contactId.PeakEncryption() } });
      }
      break;
    case TransactionType.Receipt:
      if (transactionTypeModel.financeType == FinanceType.InFlow) {
        router.push({ name: "receiptCreate", query: { eci: contactId.PeakEncryption() } });
      }
      break;
    case TransactionType.Invoice:
      if (transactionTypeModel.financeType == FinanceType.InFlow) {
        router.push({ name: "invoiceCreate", query: { eci: contactId.PeakEncryption() } });
      } else {
        router.push({ name: "expenseCreate", query: { eci: contactId.PeakEncryption() } });
      }
      break;
    default:
      break;
  }
}

function ValidateContactError(contact: any) {
  if (
    !contact.prefixOtherName.validateError &&
    !contact.registeredAddress.contactName.validateError &&
    !contact.registeredAddress.address.validateError &&
    !contact.registeredAddress.road.validateError &&
    !contact.registeredAddress.building.validateError &&
    !contact.registeredAddress.city.validateError &&
    !contact.registeredAddress.state.validateError &&
    !contact.registeredAddress.district.validateError &&
    !contact.registeredAddress.amphoe.validateError &&
    !contact.registeredAddress.province.validateError &&
    !contact.registeredAddress.zipcode.validateError &&
    !contact.shippingAddress.contactName.validateError &&
    !contact.shippingAddress.address.validateError &&
    !contact.shippingAddress.road.validateError &&
    !contact.shippingAddress.building.validateError &&
    !contact.shippingAddress.city.validateError &&
    !contact.shippingAddress.state.validateError &&
    !contact.shippingAddress.district.validateError &&
    !contact.shippingAddress.amphoe.validateError &&
    !contact.shippingAddress.province.validateError &&
    !contact.shippingAddress.zipcode.validateError &&
    !contact.email.validateError &&
    !contact.phoneNumber.validateError &&
    !contact.faxNumber.validateError &&
    !contact.website.validateError &&
    !contact.setDueDate.dayForExpenses.validateError &&
    !contact.setDueDate.dayForInvoicePayment.validateError &&
    !contact.lastname.validateError &&
    !contact.contactCode.validateError &&
    !contact.setDueDate.dayForInvoicePayment.validateError &&
    !contact.setDueDate.dayForExpenses.validateError &&
    !contact.contactCreditLimit.validateError &&
    !(contact.companyName.validateError || contact.firstname.validateError)
  ) {
    return true;
  } else {
    return false;
  }
}

function ValidateContactErrorList(contact: any) {
  let isCheckValidateContact = false;
  if (contact.personToContact !== null) {
    for (let count = 0; count < contact.personToContact.length; count++) {
      if (
        !contact.personToContact[count].firstName.validateError &&
        !contact.personToContact[count].lastName.validateError &&
        !contact.personToContact[count].nickName.validateError &&
        !contact.personToContact[count].position.validateError &&
        !contact.personToContact[count].email.validateError &&
        !contact.personToContact[count].phoneNumber.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  if (contact.bankInformation !== null) {
    for (let count = 0; count < contact.bankInformation.length; count++) {
      if (
        !contact.bankInformation[count].accountName.validateError &&
        !contact.bankInformation[count].accountNumber.validateError &&
        !contact.bankInformation[count].bankBranch.validateError
      ) {
        isCheckValidateContact = true;
      }
    }
  }
  return isCheckValidateContact;
}

export function ValidateInsertContact(contact: any) {
  if (
    contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
    contact.typeCompany.value == MerchantType.OrdinaryPerson
  ) {
    contact.firstname.validateError = contact.firstname.value == "";
    if (contact.prefixName.value == PrefixNameType.Other) {
      contact.prefixOtherName.validateError = contact.prefixOtherName.value == "";
    }
  } else {
    if (contact.companyName.value == "") {
      contact.companyName.validateError = true;
    } else {
      contact.companyName.validateError = false;
    }
  }

  if (contact.contactCode.value == "") {
    contact.contactCode.validateError = true;
  }
  if (contact.setDueDate.dayForExpenses.value > 366) {
    contact.setDueDate.dayForExpenses.validateError = true;
  }
  if (contact.setDueDate.dayForInvoicePayment.value > 366) {
    contact.setDueDate.dayForInvoicePayment.validateError = true;
  }
  if (ValidateContactError(contact) && ValidateContactErrorList(contact)) {
    return true;
  } else {
    return false;
  }
}

function BankInformation(_bankInfoList: any) {
  const bankInfoTemplate = [];
  if (_bankInfoList !== null) {
    for (let count = 0; count < _bankInfoList.length; count++) {
      const bankInfo = _bankInfoList[count];
      const bankInfoItem = {
        id: bankInfo.id,
        bankName: bankInfo.bank.name,
        accountNumber: bankInfo.accountNumber.value,
        accountName: bankInfo.accountName.value,
        branch: bankInfo.bankBranch.value,
        bankReferenceBankId: bankInfo.bank.bankReferenceBankId >= 0 ? bankInfo.bank.bankReferenceBankId : null,
      };
      bankInfoTemplate.push(bankInfoItem);
    }
  }
  return bankInfoTemplate;
}

function PersonToContact(_personToContactList: any) {
  const personToContactTemplate = [];
  if (_personToContactList !== null) {
    for (let count = 0; count < _personToContactList.length; count++) {
      const personContact = _personToContactList[count];
      const personContactItem = {
        id: personContact.id,
        firstname: personContact.firstName.value,
        lastname: personContact.lastName.value,
        nickname: personContact.nickName.value,
        position: personContact.position.value,
        personPhone: personContact.phoneNumber.value,
        personEmail: personContact.email.value,
        isMainPerson: 1,
        isSendEmail: 1,
        personalNamePrefixTypeId: personContact.prefixName.value,
        personalNamePrefixOther: personContact.prefixOtherName.value,
        departmentTypeId: personContact.department.value,
        departmentOther: personContact.departmentOther.value,
      };
      personToContactTemplate.push(personContactItem);
    }
  }
  return personToContactTemplate;
}

export function InputInsertContactTemplate(_contact: any) {
  const contact = {
    id: _contact.id,
    name:
      _contact.typeOfPerson.value == TypeOfPerson.OrdinaryPerson &&
      _contact.typeCompany.value == MerchantType.OrdinaryPerson
        ? _contact.firstname.value + " " + _contact.lastname.value
        : _contact.companyName.value,
    isVat: 0,
    email: _contact.email.value,
    phone: _contact.phoneNumber.value,
    address: {
      address: _contact.shippingAddress.address.value,
      subDistrict: _contact.contactContryId == 1 ? _contact.shippingAddress.district.value : "",
      district:
        _contact.contactContryId == 1 ? _contact.shippingAddress.amphoe.value : _contact.shippingAddress.city.value,
      province:
        _contact.contactContryId == 1 ? _contact.shippingAddress.province.value : _contact.shippingAddress.state.value,
      country: _contact.shippingAddress.country ? _contact.shippingAddress.country.name : "",
      road: _contact.contactContryId == 1 ? null : _contact.shippingAddress.road.value,
      building: _contact.contactContryId == 1 ? null : _contact.shippingAddress.building.value,
      postCode: _contact.shippingAddress.zipcode.value,
    },
    merchantType: _contact.typeCompany.value,
    contactName: _contact.shippingAddress.contactName.value,
    fax: _contact.faxNumber.value,
    website: _contact.website.value,
    code: _contact.contactCode.value,
    invoiceIncomeType: _contact.setDueDate.dueToInvoicePayment.value,
    invoiceIncomeValue: _contact.setDueDate.dayForInvoicePayment.value,
    accountsReceivableAccountId: _contact.accountRecordSetting.selectReceivableRecorded.id,
    invoiceExpenseType: _contact.setDueDate.dueToExpenses.value,
    invoiceExpenseValue: _contact.setDueDate.dayForExpenses.value,
    accountsPayableAccountId: _contact.accountRecordSetting.selectPayableRecorded.id,
    personalNamePrefixType: _contact.prefixName.value,
    personalNamePrefixOther: _contact.prefixName.value == PrefixNameType.Other ? _contact.prefixOtherName.value : null,
    taxId: _contact.taxId.value,
    bankInformation: BankInformation(_contact.bankInformation),
    personToContact: PersonToContact(_contact.personToContact),
    contactBranchModel: {
      id: _contact.contactBranchId,
      name: _contact.registeredAddress.contactName.value,
      branchCode: _contact.branchTypeId == 1 ? "00000" : _contact.branchCode.value,
      address: {
        address: _contact.registeredAddress.address.value,
        subDistrict: _contact.contactContryId == 1 ? _contact.registeredAddress.district.value : "",
        district:
          _contact.contactContryId == 1
            ? _contact.registeredAddress.amphoe.value
            : _contact.registeredAddress.city.value,
        province:
          _contact.contactContryId == 1
            ? _contact.registeredAddress.province.value
            : _contact.registeredAddress.state.value,
        country: _contact.registeredAddress.country.name,
        road: _contact.contactContryId == 1 ? null : _contact.registeredAddress.road.value,
        building: _contact.contactContryId == 1 ? null : _contact.registeredAddress.building.value,
        postcode: _contact.registeredAddress.zipcode.value,
      },
    },
    contactCreditLimit: _contact.contactCreditLimit.value,
    creditLimitSettingType: _contact.creditLimitSettingType,
  };
  return contact;
}

export function ExceptionInsertContactTemplate(res: any, contact: any) {
  switch (res.exception.code) {
    case PeakExceptionResponseCode.ContactCodeIsDuplicated:
      contact.contactCode.validateError = true;
      return "รหัสผู้ติดต่อซ้ำ กรุณาระบุรหัสผู้ติดต่อใหม่";
      break;
    case PeakExceptionResponseCode.ContactNameIsDuplicated:
      contact.companyName.validateError = true;
      return "ชื่อผู้ติดต่อซ้ำ";
      break;
    case PeakExceptionResponseCode.TaxIdIsDuplicated:
      return "เลขทะเบียน 13 หลักนี้มีการเพิ่มเป็นผู้ติดต่อของคุณใว้แล้ว";
      break;
  }
}

export function ExceptionCheckDuplicate(res: any, contact: any) {
  const contactDuplicate = {
    contactName: "",
    contactDuplicateType: ContactDuplicateType.None,
  };
  switch (res.exception.code) {
    case PeakExceptionResponseCode.ContactNameIsDuplicated:
      contactDuplicate.contactName =
        contact.typeOfPerson.value == 1
          ? contact.firstname.value + " " + contact.lastname.value
          : contact.companyName.value;
      contactDuplicate.contactDuplicateType = ContactDuplicateType.Name;
      break;
    case PeakExceptionResponseCode.TaxIdIsDuplicated:
      contactDuplicate.contactName = contact.taxId;
      contactDuplicate.contactDuplicateType = ContactDuplicateType.TaxId;
      break;
  }
  return contactDuplicate;
}

export function ToContactList(_contactList: any) {
  const contactList = [];
  if (_contactList !== null) {
    for (let i = 0; i < _contactList.length; i++) {
      const contactData = {
        id: _contactList[i].id,
        contactBranchCode: _contactList[i].contactBranchCode,
        contactTaxId: _contactList[i].contactTaxId,
        contactCode: _contactList[i].contactCode,
        contactFullName: _contactList[i].contactFullName,
        contactFullNameEng: _contactList[i].contactFullNameEng,
        contactFullNameTh: _contactList[i].contactFullNameTh,
        contactShortName: _contactList[i].contactShortName,
        contactShortNameEng: _contactList[i].contactShortNameEng,
        contactShortNameTh: _contactList[i].contactShortNameTh,
        contactName: _contactList[i].contactName,
        contactType: _contactList[i].contactType,
        incomeDueDateTypeId: _contactList[i].incomeDueDateTypeId,
        incomeDueDateDay: _contactList[i].incomeDueDateDay,
        outflowDueDateTypeId: _contactList[i].outflowDueDateTypeId,
        outflowDueDateDay: _contactList[i].outflowDueDateDay,
        address: _contactList[i].address,
        phoneNumber: _contactList[i].contactPhoneNumber,
        email: _contactList[i].contactEmail,
        webSite: _contactList[i].contactWebSite,
        personFirstName: _contactList[i].personFirstName,
        personLastName: _contactList[i].personLastName,
        personNickName: _contactList[i].personNickName,
        personEmail: _contactList[i].personEmail,
        personPhone: _contactList[i].personPhone,
        contactWhtType: _contactList[i].contactWhtType,
        status: "null",
        logoUrl: _contactList[i].logoUrl,
        creditLimit: _contactList[i].creditLimit,
        creditLimitSettingType: _contactList[i].creditLimitSettingType,
        isArchived: _contactList[i].isArchived,
        isDeleted: _contactList[i].isDeleted,
      };
      contactList.push(contactData);
    }
  }
  return contactList;
}
